import { Button, Input, Space } from 'antd';
import BriefsList from 'components/BriefsList';
import ChannelDetail from 'components/channel/ChannelDetail';
import BriefIcon from 'components/commons/BriefIcon';
import JsonLog from 'components/commons/JsonLog';
import NotFoundContent from 'components/commons/NotFoundContent';
import ShareComponent from 'components/commons/ShareComponent';
import SwitchStatus from 'components/commons/SwitchStatus';
import CardContainer from 'components/layout/CardContainer';
import Loading from 'components/layout/Loading';
import MainContainer from 'components/layout/MainContainer';
import SeoComponent from 'components/layout/SeoComponent';
import SubHeader from 'components/layout/SubHeader';
import SubHeaderChannel from 'components/layout/SubHeaderChannel';
import TopBar from 'components/layout/TopBar';
import { createEmptyBrief, NewBrief } from 'constants/brief.helpers';
import { checkValidUrl, cleanText } from 'constants/helpers';
import ROUTES from 'constants/Routes';
import withSession from 'lib/session';
import { debounce } from 'lodash';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import React, { useEffect, useMemo, useState } from 'react';
import LocalStorage from 'services/LocalStorage';
import { composeHeaders, getReqSession } from 'services/server/ServerHelpers';
import ServiceBriefs from 'services/ServiceBriefs';
import ServiceChannels from 'services/ServiceChannels';
import { Brief, Channel, User } from 'store/types';
import { useStore } from 'store/zustandProvider';
import COLORS from 'styles/Colors';

const CommonTour = dynamic(import('components/commons/CommonTour'), {
  ssr: false
});

interface BusinessChannelPageProps {
  user: User;
  channel: Channel;
  channelUUID: string;
  brief?: Brief;
  privateChannel?: boolean;
}
const BusinessChannelPage: React.FC<BusinessChannelPageProps> = ({
  channel: initialChannel,
  user,
  brief,
  channelUUID,
  privateChannel = false
}) => {
  const router = useRouter();
  const { setChannel: setStoreChannel, setUser, isCoeditor } = useStore();
  const [channel, setChannel] = useState<Channel>(initialChannel);
  const [loading, setLoading] = useState(true);

  const { me, ownChannel } = useStore();
  const [isPrivateChannel, setIsPrivateChannel] = useState(privateChannel);
  const [isTourOpen, setIsTourOpen] = useState(false);

  const [showBriefRow, setShowBriefRow] = useState(false);
  const [newBriefUrl, setNewBriefUrl] = useState('');
  const [isValidUrl, setIsValidUrl] = useState(false);

  const isMyPage = useMemo(() => {
    return me?.uuid && me?.uuid === channel?.author?.uuid
  }, [
    me,
    user,
    channel
  ]);



  const steps = useMemo(
    () => [
      {
        selector: '#channelTitle',
        content: 'Add your channel Title'
      },
      {
        selector: '#channelDescription',
        content: 'Add your channel Desscription'
      },
      {
        selector: '.channelImage .ant-upload-drag-container',
        content: 'Add your cover image'
      },

      {
        selector: '.briefIcon.add',
        content: ({ goTo }) => (
          <div className="textCenter">
            Add your first Brief <br />
            <br />
            <Button type="primary" onClick={() => setIsTourOpen(false)}>
              Begin
            </Button>
          </div>
        )
      }
    ],
    []
  );

  useEffect(() => {
    if (user) setUser(user);
    if (channel) {
      setStoreChannel(channel);
    }
  }, [me, user, channel, isMyPage, isPrivateChannel]);

  useEffect(() => {
    getChannel();
  }, []);

  useEffect(() => {
    if (!channel?.briefs?.length && me && isMyPage) {
      if (!LocalStorage.getItem('wizardBriefsDone')) {
        LocalStorage.setItem('wizardBriefsDone', 1);
        setIsTourOpen(true);
      }
    }
  }, [me, user, channel, isMyPage]);

  const _getChannel = async () => {
    console.count('🚀 ~ getChannel ');
    setLoading(true);

    ServiceChannels.business
      .get({
        channelUUID
      })
      .then((channel) => {
        setChannel(channel);
        setStoreChannel(channel);
      })
      .catch((e) => {
        console.warn(e);
        setIsPrivateChannel(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getChannel = useMemo(
    () => debounce(_getChannel, 2000, { leading: true, trailing: true }),
    []
  );

  const onClickedBrief = (brief: Brief) => {
    console.log('🚀 ~ onClickedBrief ~ brief', brief);

    if (brief?.channel?.rule >= 2 || isMyPage) {
      router.push(ROUTES.business.getBriefPage(brief.uuid));
    }
  };
  const onChangedUrl = ({ target: { value } }) => {
    const url = cleanText(value);
    console.log('🚀 ~ onChangedUrl ~ url', url);

    setIsValidUrl(checkValidUrl(url));

    setNewBriefUrl(url);
  };

  const addBrief = async () => {
    setShowBriefRow(true);
  };

  const createBrief = async () => {
    if (!isValidUrl) return false;
    setLoading(true);
    return ServiceBriefs.getContent({ link: newBriefUrl, size: 1 })
      .then((content) => {
        console.log('🚀 ~ ServiceBriefs.createSummary ~ content', content);

        const tempBrief: NewBrief = createEmptyBrief({
          uuidChannel: channelUUID,
          content,
          channel: channel
        });

        LocalStorage.setItem('tempBrief', tempBrief);
        router.push(ROUTES.business.createBrief(channelUUID));
      })
      .finally(() => setLoading(false));
  };

  const clearBrief = () => {
    setNewBriefUrl('');
    setShowBriefRow(false);
  };



  return (
    <MainContainer
      id="BusinessChannelPage"
      className={`${channel?.briefs?.length === 0 && 'noItems'}`}
      topBar={<TopBar />}>
      <SeoComponent channel={channel} brief={brief} />


      {
        loading ? <Loading /> :
          <React.Fragment>

            {
              (isPrivateChannel && !isMyPage) ? <NotFoundContent title="Content Not Found" subTitle="" /> :

                <React.Fragment>


                  {isMyPage && (
                    <SubHeader>
                      <SubHeaderChannel channelUUID={channelUUID} current="post" />
                      <Space className="channelSubheaderActions" align="center">
                        <SwitchStatus channel={channel} />
                        <ShareComponent />
                      </Space>
                    </SubHeader>
                  )}

                  {/* <Button onClick={() => setIsTourOpen((isOpen) => !isOpen)}>toggle Tour</Button> */}
                  <CardContainer>
                    <ChannelDetail channel={channel} isMyPage={isMyPage}>
                      {(isMyPage || isCoeditor) && (
                        <BriefIcon
                          icon="Add"
                          title="Create new Brief"
                          color={COLORS.main}
                          onClick={addBrief}
                          className="addIconFill"
                        />
                      )}
                    </ChannelDetail>
                    {showBriefRow && (
                      <div className="addBriefRow">
                        <div className="flexRow">
                          <Input
                            onChange={onChangedUrl}
                            value={newBriefUrl}
                            placeholder="Type or paste link here"
                            allowClear
                            onPressEnter={createBrief}
                          />
                          <Button
                            type="primary"
                            className="createBrief"
                            loading={loading}
                            onClick={createBrief}
                            disabled={!isValidUrl}>
                            Add Brief
                          </Button>
                          <Button loading={loading} onClick={clearBrief}>
                            Cancel
                          </Button>
                        </div>
                      </div>
                    )}

                    <Loading spinning={loading}>
                      <BriefsList
                        briefs={channel?.briefs}
                        channelUUID={channelUUID}
                        onAction={getChannel}
                        onClickedBrief={onClickedBrief}
                      />
                    </Loading>
                  </CardContainer>

                  <JsonLog src={{ channel, channelUUID, me, user, isMyPage, ownChannel }} />

                  <CommonTour visible={isTourOpen} steps={steps} onClose={() => setIsTourOpen(false)} />

                </React.Fragment>


            }
          </React.Fragment>

      }



    </MainContainer>
  );
};

export default BusinessChannelPage;

export const getServerSideProps = withSession(async function ({ req, res, params, query }) {
  const { channelUUID } = params;
  const { briefUUID } = query;
  const querySubdomain = query?.subdomain;

  let privateChannel = false;
  if (!channelUUID || channelUUID === 'null') {
    return {
      props: {
        channel: null,
        brief: null,
        user: {}
      }
    };
  }
  const { Authorization, deviceToken, subdomain: sessionSubdomain } = getReqSession(req);
  const subdomain = querySubdomain || sessionSubdomain;
  const user = req.session.get('user') || '';
  const headers = composeHeaders(req);

  if (!headers.subdomain) {
    headers.subdomain = subdomain;
  }
  try {
    const channel = await ServiceChannels.business.get({
      channelUUID,
      headers: { subdomain }
    });

    console.log('🚀 ~ getServerSideProps ~ channel', channel);

    if (channel.status === 0 && !user) {
      //Private channel
      privateChannel = true;
      return {
        props: {
          channelUUID,
          channel: null,
          brief: null,
          user: {},
          privateChannel
        }
      };
    }
    let brief: Brief = null;
    if (briefUUID) {
      brief = channel.briefs.find((bf) => bf.uuid === briefUUID) || null;
    }
    return {
      props: {
        channelUUID,
        channel,
        brief,
        user
      }
    };
  } catch (e: any) {
    console.error(e);
    privateChannel = true;
    return {
      props: {
        channelUUID,
        channel: null,
        brief: null,
        privateChannel,
        user: {}
      }
    };
  }
});
